import { request } from '@utils';
import { LIMIT } from '@constants';

const searchTires = async (queryParams = {}, payload = {}) => {
  if (!queryParams?.page) {
    queryParams.page = 1;
  }

  if (!queryParams?.pageSize) {
    queryParams.pageSize = LIMIT;
  }

  const body = {
    body: payload,
  };

  const results = await request.post(
    `/v1/tires/filter?${new URLSearchParams(queryParams)}`,
    body
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const updateTire = async (id, params) => {
  const body = {
    body: params,
  };

  const results = await request.patch(`/v1/tires/${id}`, body);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getEnums = async () => {
  const results = await request.get(`/v1/tires/enums`);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

export { searchTires, updateTire, getEnums };
